
import axios from 'axios';
import authHeader from './auth-header'; // Asegúrate de que esto esté configurado

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
    getColors() {
        const url = `${API_URL}/colors`; // Si pageUrl es null, usa la URL base
        return axios.get(url, { headers: authHeader() });
    },
    createData(data) {
        return axios.post(`${API_URL}/colors`, data, { headers: authHeader() });
    },
    deleteData(id) {
        return axios.delete(`${API_URL}/colors/${id}`, { headers: authHeader() });
    },
};